import React from "react";
import { Title, Text } from "rizzui/typography";
import { Button } from "rizzui";
import AccountBox from "../../component/accountBox";
export default function ResetSuccesful() {
  return (
    <AccountBox>
      <div className="flex flex-col gap-[32px]">
        <div className="flex flex-col gap-[8px]">
          <Title className="text-[18px] font-[600] text-primary-dark text-center font-ibmPlexSerif">
            {" "}
            Password reset successful{" "}
          </Title>
          <Text className="text-[14px] font-[400] text-secondary-dark text-center font-switzer">
            You’ve successfully reset your password, kindly log in to continue
            using Ringconnect
          </Text>
        </div>

        <div className="text-secondary-dark font-switzer text-center">
          <a href="/account/login">
            <Button
              variant="solid"
              className="!bg-btn rounded-[4px] text-[12px] font-switzer font-[500] w-[216px] h-[40px]"
            >
              Log in
            </Button>
          </a>
        </div>
      </div>
    </AccountBox>
  );
}
